import React from 'react';
import CusPageContainer from '../../../../components/shared/CusPageContainer';
import GameProviderContent from './GameProviderContent';

export default function SettingGameProvider() {
  return (
    <CusPageContainer title="Game providers">
      <GameProviderContent />
    </CusPageContainer>
  );
}
